import React, { Component, createRef } from 'react';


import { grey, purple } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { ResponsiveContainer} from 'recharts';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import L, { LatLngBoundsExpression } from 'leaflet';
//import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import PageBase from '../site/PageBase';
//import LiveMap from './LiveMap';
import {apipost, apiraw, bizpost} from '../../ajax';
import { LatLngExpression } from 'leaflet';
import metericon from '../icons/meter.png';
import apply from '../icons/receipt.svg';
import pay from '../icons/pay-per-click.svg';
import submit from '../icons/submit.svg';
import process from '../icons/thinking.svg';
import complete from '../icons/task-complete.svg';
import BadgeMarker, { AnimatedBadgeMarker } from '../maps';
import { Box } from '@mui/material';

const s:any = {
  root: {
    flexGrow: 1,
    flexShrink: 1,
  },
  // navigation: {
  //   fontSize: 15,
  //   fontWeight: 300,
  //   color: grey['600'],
  //   paddingBottom: 15,
  //   display: 'block'
  // },
  // title: {
  //   fontSize: 24,
  //   fontWeight: 300,
  //   marginBottom: 20,
  //   color:'white'
  // },
  // paper: {
  //   padding: 5,
  // },
  // clear: {
  //   clear: 'both'
  // },
  boardpaper: {
    backgroundColor: 'white',
    //maxHeight: 600,
    height: '100%',
    // height: 150
    ml: 1,
    mr: 1,
  },
  div: {
    // height: 95,
    //padding: '5px 15px 0 15px'
  },
  header: {
    fontSize: 24,
    fontWeight: 'typography.fontWeightLight',
    color: 'white',
    backgroundColor: purple['600'],
    padding: 1,
  }
};

// const metericons:any = {
//   NRMMS: {
//     "1P":L.icon({iconUrl:apply,shadowUrl:iconShadow}),
//     "3P":L.icon({iconUrl:pay,shadowUrl:iconShadow}),
//   },
//   NFMMS: {
//     "1P":L.icon({iconUrl:submit,shadowUrl:iconShadow}),
//     "3P":L.icon({iconUrl:process,shadowUrl:iconShadow}),
//   }
// }

const xsicons:any = {
  UNKNOWN:L.icon({iconUrl:apply,shadowUrl:iconShadow}),
  INITIATED:L.icon({iconUrl:pay,shadowUrl:iconShadow}),
  COMPLETED:L.icon({iconUrl:submit,shadowUrl:iconShadow}),
  FAILED:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  CANCELLED:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  TIMEOUT:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
  DUPLICATE:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
}

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

// const MapIcon:L.Class = L.Icon.extend({
//   options: {
//     iconUrl: metericon,
//     iconSize: [7.5, 7.5],
//     iconAnchor: [0, 0]
//   }
// });

class Mapboard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  map: any;
  constructor(props:any) {
    super(props);

    this.map = createRef();

    this.state = {
      //dd: this.props.userData.dd,
      ping: null,
      timer: 60000, //300000,
      count:0,
      offset: 0,
      limit: 1000,
      loading: false,
      lastread: null,
      recordset: [],
      previousset:[],
      currentset:[],
      maplayer: null,
      center:[5.64046614, -0.2921927],
      zoom: 13,
      regmap: null,
      dismap: null,
    };
  }

  // componentDidMount(): void {
  //   // const map = useMap()
  //   // console.log('map center:', map.getCenter())
  //   // return null
  //   const cmap = this.map.current;
  //   console.log('map',cmap);
  //   cmap.on('zoomend',this.onZoom);

  // } 

  componentDidMount() {
    const cmap = this.map.current;
    console.log('map',cmap);
    //cmap.on('zoomend',this.onZoom);
    this.baseload();
    //
    const {timer } = this.state;
    var ping = setInterval(this.refresh,timer);
    this.setState({ ping: ping });
  }

  componentWillUnmount() {
    if (this.state.ping) clearInterval(this.state.ping);
  }

  refresh = async() => {
    try {
      const {center:ocenter,recordset:previousset,lastread} = this.state;
      const {offset:ofs,limit:lim} = this.state;
      const baseparams = { s: "mapboard", a: "get",ofs,lim };
      const response = await bizpost(baseparams);
      const {cc:ncenter,rc,sd:currentset} = response;
      const recordset = this.merge('rid',previousset,currentset);
      const offset = ofs+rc;
      const center = ncenter || ocenter;
      this.setState({center,recordset,previousset,currentset,offset});
    } catch (error) {
      console.log("refresh error", error);
      this.sessionError(error);
    }
  }

  sessionError(error: any) {
    const { type, name, title, data } = error || {};
    if (type === "error" && name === "fetcherror" && title === "Unauthorised") {
      const { failure, code } = data || {};
      if (failure === true && code === 401) {
        //session expired. reload page.
        //this.props.doRestart('Session Expired. reloading...');
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    }
  }

  // componentDidMount(){
  //   const {timer} = this.state;
  //   var ping = setInterval(async()=>{
  //     try{
  //       const baseparams = {s:'security',a:'dashdata'};
  //       const response = await bizpost(baseparams);
  //       //console.log('dd resp',response);
  //       this.setState({dd:response.dd});
  //     }
  //     catch(error){
  //       console.log('dd error',error);
  //     } 
  //   },timer);
  //   this.setState({ping:ping});
  // }

  // componentWillUnmount(){
  //   if(this.state.ping) clearInterval(this.state.ping);
  // }

  mapload = async(file:string) => {
    try{
      const baseparams = {file}; //,sta:date
      const response = await apiraw('/api/resource/maps','',baseparams);
      return response; //TODO: return file
    }
    catch(error){
      console.log('mapload error',error);
      return Promise.reject(error);
    } 
  //TODO: call LoadMarkers
  
  }

  baseload = async() => {
    try{
      const rs = await this.mapload('ghana_regions.json');
      //console.log('regmap.rs',rs);
      this.setState({regmap:rs});

      const ds = await this.mapload('ghana_towns.json');
      //console.log('dismap.ds',ds);
      this.setState({dismap:ds});
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }

  merge = (p:string, ...arrs:any[]) => [].concat(...arrs).reduce((a, b) => !a.filter(c => b[p] === c[p]).length ? [...a, b] : a, []);

  dedupe = (field:string,data:any[]) => Object.values(
    data.reduce((acc, rec) => {
        const key = rec[field]; // Field to check for duplicates

        if (!acc[key]) {
            // If the key is not in the accumulator, initialize it with the item and set count to 1
            acc[key] = { ...rec, count: 1 };
        } else {
            // If the key exists, increment the count of the retained record
            acc[key].count++;
        }
        return acc;
    }, {}) // Start with an empty object {}
  );

  remerge = (f:string, p:string, ...arrs:any[]) => this.dedupe(f,this.merge(p,...arrs));


  ttFormatTime = (stamp:any) => {
    return moment.unix(stamp).format('DD MMM');
  }

  onZoom = () => {
    try{
      const actualZoom = this.map.getZoom();
      const newSize = 60/((20 - actualZoom )*2);
      //const resizedIcon = new MapIcon({iconSize: [newSize, newSize ]});      
      //marker.setIcon(resizedIcon );
    }
    catch(err){
      console.log('Map Zoom Error:', err);
    }
  }


  render() {
    const {title,userData,classes,theme} = this.props;
    //const {center,zoom} = this.state;
    const {recordset=[],maplayer} = this.state;
    const {regmap,dismap} = this.state;
    //const {recordset,previousset,currentset} = this.state;
    console.log('userData',userData);
    console.log('recordset',recordset);
    const records = this.dedupe('lci',recordset);
    const {bd} = userData ||{};
    //const mcenter:LatLngExpression = center||[8.977850, 39.253099]; 
    //const mpos:LatLngExpression = center||[9.01055, 38.74750];
        
    //const mapcenter:LatLngExpression = center; //[7.5823, -1.9470];
    //const apexpos:LatLngExpression = [9.01055, 38.74750]; //[6.647991, -0.579113];
    const apextext = `APEXMOMO Event.`;
    //const bounds = new  L.LatLngBounds([[4.5392525, -3.260786],[11.1748562,	1.2732942]]);
    //const bounds:LatLngBoundsExpression = [[4.5392525, -3.260786],[11.1748562,	1.2732942]];
    //-3.24437008301, 4.71046214438, 1.0601216976, 11.0983409693
    //const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    const bounds:LatLngBoundsExpression = [[4.51046214438, -3.75437008301],[11.4983409693, 1.2701216976]];
    const center:LatLngExpression = [8.00946644, -1.2221927];
    const zoom = 8;
    
    return (
      <PageBase navigation="APEXMOMO / Map board" subid={(bd||{}).eni}>
 
            <Paper sx={{...s.boardpaper}}>
              <Box sx={{...s.header}}>{title}</Box>
              <Box sx={{...s.div}}>
                <ResponsiveContainer >
                  <MapContainer 
                    //ref={this.map} 
                    center={center} 
                    zoom={zoom} 
                    scrollWheelZoom={false} 
                    style={{height:'100vh',width:'100%',minHeight:1200}} 
                    bounds={bounds}
                    
                  >
                    <TileLayer
                      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" bounds={bounds}
                    />
                    {regmap && <GeoJSON attribution="&copy; credits due..." data={regmap} style={{color:'#6699EE'}} />}
                    {dismap && <GeoJSON attribution="&copy; credits due..." data={dismap} style={{color:'#999999'}} />}
                    {/* <Marker position={mapcenter}>
                      <Popup>
                        {apextext}
                      </Popup>
                    </Marker> */}
                    {/* {recordset.map((record:any, idx:number) => 
                      <Marker key={record.rid} position={record.geo}>
                      <Popup>
                        <Box component='span'>STS:{record.sno}<br/>METER:{record.mno}<br/>DISTRICT: {record.mmd}<br/>MODEL: {record.mtc}<br/>PHASE: {record.mpc}</Box>
                      </Popup>
                    </Marker>
                    )} */}
                    {(records.length > 0) && records.map((record:any, idx:number) => 
                    <AnimatedBadgeMarker  key={record.rid} 
                      position={record.geo}
                      value={record.count||0}
                      badgeColor="rgba(255, 31, 221, 1)"
                      textColor="#fff"
                      sx={{ fontWeight: "bold" }}
                    >
                      <Popup>
                        <Box component='span'>
                          <u><b>MOMO TRANSACTION</b></u><br/>
                          <b>TRACK.ID:</b> {record.tri}<br/>
                          <b>REF.NO:</b> {record.rfn}<br/>
                          <b>MMC:</b> {record.clc}<br/>
                          <b>RCB:</b> {record.bkn}<br/>
                          <b>BRANCH:</b> {record.brn}<br/>
                          <b>TYPE:</b> {record.xtc}<br/>
                          <b>STATUS:</b> {record.xsc}<br/>
                          <b>DATE:</b> {record.dcd}
                        </Box>
                      </Popup>
                    </AnimatedBadgeMarker>
                    )}
                  </MapContainer>
                </ResponsiveContainer>
              </Box>
            </Paper>
  
      </PageBase>
    );
  }
};

export default Mapboard;
